<div [formGroup]="addressFormGroup">
  <div class="mb-4">
    <gc-address-block
      [addressFormGroup]="addressFormGroup"
      [countryDisabled]="true"
      [allowedOrgLocations]="allowedOrgLocations">
    </gc-address-block>
  </div>
</div>